import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { AuthenticationContext } from '../../../shared/contexts/authentication.context';
import { CurrentUser, Privilege } from '../../../shared/models/generated/ziroModels';
import { take } from 'rxjs/operators';

@Component({
  selector: 'ziro-custom-reports',
  templateUrl: './custom-reports.component.html',
  styleUrls: ['../../reporting.scss'],
  standalone: false,
})
export class CustomReportsComponent implements OnInit, OnDestroy {
  private breadcrumbsService = inject(BreadcrumbsService);
  private authenticationContext = inject(AuthenticationContext);

  isReadOnly = false;

  ngOnInit(): void {
    this.authenticationContext.state$.pipe(take(1)).subscribe((user: CurrentUser) => {
      this.isReadOnly = !user.privileges.includes(Privilege.CONTROL_WRITE);
    });
  }

  ngOnDestroy(): void {
    this.breadcrumbsService.clearBreadcrumbs();
  }
}
